export var mixSection = 'html-email-body-section-mix';
export var mixSectionNoWrap = 'html-email-body-section-mix-no-wrap';
export var mixColumnNoWrap = 'html-email-mix-column-no-wrap';
export var mixColumn = 'html-email-mix-column';
export var mixLeftColumn = 'html-email-mix-left-column';
export var mixRightColumn = 'html-email-mix-right-column';
export var mixButton = 'html-emails-mix-button';
export var mixText = 'html-emails-mix-text';
export var mixImageWrapper = 'html-emails-mix-image-wrapper';
export var mixImageWrapperFullWidth = 'html-emails-mix-image-wrapper-full-width';
export var mixSpacer = 'html-emails-region-mix-spacer';
//# sourceMappingURL=mix-css-classes.js.map